import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { GeneratorCapacityModal } from "./generatorCapacityModal";
import { ConsumerCapacityModal } from "./consumerCapacityModal";
import "../../../Styles/Analyst/AnalystProfile.css";
import { BankingSlot } from "../../Auth/Banking/bankingSlot";
import DownloadIcon from "@mui/icons-material/Download";
import analystService from "../../../components/Services/analyst.service";
const CapacityListingByUser = ({
  item,
  myProfileDetails,
  handleCapacityListing,
  active,
}) => {
  console.debug(item?.requiredQty);
  const [isModel, setIsModel] = useState(false);

  const handleEditClick = (item) => {
    setIsModel(item);
    handleCapacityListing();
  };

  const downloadExcelFilesFromBase64 = (file) => {
    // Convert base64 to binary
    const binaryString = atob(file?.fileInBytes);

    // Convert binary to ArrayBuffer
    const arrayBuffer = new ArrayBuffer(binaryString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }

    // Create Blob from ArrayBuffer
    const blob = new Blob([uint8Array], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create download link
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = file.fileName || `logs.xlsx`; // Use a default name if fileName is not provided

    // Append the link to the body
    document.body.appendChild(downloadLink);

    // Trigger the click event to start the download
    downloadLink.click();

    // Remove the link from the body
    document.body.removeChild(downloadLink);
  };

  const handleDownloadLogs = (id) => {
    analystService
      .getListingLogsBanking(id)
      .then((res) => {
        console.debug(res);
        downloadExcelFilesFromBase64(res?.data?.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      {isModel &&
        active !== "BANKING" &&
        (active === "GENERATOR" ? (
          <GeneratorCapacityModal
            isOpen={isModel}
            handleSubmit={handleEditClick}
            myProfileDetails={myProfileDetails}
            handleCapacityListing={handleCapacityListing}
          />
        ) : (
          <ConsumerCapacityModal
            isOpen={isModel}
            handleSubmit={handleEditClick}
            myProfileDetails={myProfileDetails}
            handleCapacityListing={handleCapacityListing}
          />
        ))}
      {active === "BANKING" && isModel && (
        <BankingSlot
          isOpen={isModel}
          //   docData={docData}
          handleSubmit={handleEditClick}
        />
      )}

      <div style={{ width: "100%" }} className="capacity_details_header">
        <div style={{ display: "flex", gap: "20px" }}>
          <div>{item?.name}</div>
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleEditClick(item);
            }}
            style={{ cursor: "pointer" }}
          >
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Edit Capacity</Tooltip>}
            >
              <div>
                <i className="fa fa-pencil c-icons"></i>
              </div>
            </OverlayTrigger>

            {/* <FaPencilAlt className="dashboard-pencil" /> */}
          </div>
          {active === "BANKING" && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleDownloadLogs(item?.id);
              }}
              style={{
                cursor: "pointer",
                background: "white",
                borderRadius: "8px",
                padding: "4px",
              }}
            >
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip>{item?.name} LOGS</Tooltip>}
              >
                <DownloadIcon style={{ fontSize: "24px" }} />
              </OverlayTrigger>

              {/* <FaPencilAlt className="dashboard-pencil" /> */}
            </div>
          )}
        </div>

        {active === "BANKING" && (
          <div className="capacity_details_banking">
            <div className="capacity_each_banking">
              <div>
                <div>Region</div>
                <div>{item?.company?.region || "NA"}</div>
              </div>
              <div>
                <div>State</div>
                <div>{item?.company?.state || "NA"}</div>
              </div>
              <div>
                <div>Credit Rating</div>
                <div>{item?.company?.creditRating}</div>
              </div>
              <div>
                <div>Quantity (MW)</div>
                <div>{item?.requiredQty}</div>
              </div>
              <div>
                <div>Banking Factor</div>
                <div>{item?.bankingFactor}</div>
              </div>
              <div>
                <div>Settlement Rate (₹/KWH)</div>
                <div>{item?.settlementRate}</div>
              </div>
              <div>
                <div>Expires On</div>
                <div>{item?.expiryAt}</div>
              </div>
            </div>
            <div className="capacity_each_banking">
              <div className="injection_drawal">
                <div>Injection Range:</div>
                <div>
                  {item?.bankingSlotInjects?.map((ele) => (
                    <span>
                      {ele?.dateStartAt}/{ele?.dateEndAt} : {ele?.slotStartAt}-
                      {ele?.slotEndAt}
                    </span>
                  ))}
                </div>
              </div>
              <div className="injection_drawal">
                <div>Drawal Range:</div>
                <div>
                  {item?.bankingSlotDrawls?.map((ele) => (
                    <span>
                      {ele?.dateStartAt}/{ele?.dateEndAt} : {ele?.slotStartAt}-
                      {ele?.slotEndAt}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
        {active !== "BANKING" && (
          <div className="capacity_details">
            <div className="date-and-time">
              Date:
              <div>
                {item?.dateStartAt} - {item?.dateEndAt}
              </div>
            </div>
            <div className="date-and-time">
              Time Slot:
              <div>
                {item?.slotStartAt} -
                {item?.slotEndAt === "23:59" ? "24:00" : item?.slotEndAt}
              </div>
            </div>
            <div>
              Quantity (in MW):
              <span>
                {active === "GENERATOR"
                  ? item?.sellEnergy
                  : item?.purchaseEnergy}
              </span>
            </div>
            <div>
              {"Energy Rate(₹ / unit)"} :
              <span>
                {active === "GENERATOR" ? item?.sellingCost : item?.landingCost}
              </span>
            </div>
            {/* <div> Energy Type : <span>{item?.energyType?.type}</span></div> */}
            <div className="small"> Expires on {item?.bidEndAt}</div>
          </div>
        )}
      </div>
    </>
  );
};

export default CapacityListingByUser;
